"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*Global Closest fix for IE*/
if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i,
        that = this;

    do {
      i = matches.length;

      while (--i >= 0 && matches.item(i) !== that) {//
      }
    } while (i < 0 && (that = that.parentElement));
    /* eslint-disable-line consistent-this */


    return that;
  };
}
/*Global ForEach fix for IE*/


if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
} // NOTE: This file is auto-generated into the Legacy js as skip-navigation.js so that files stay consistent.
// Achieved via the combineSkipNavJsForLegacy task in the gulpfile.

/**
 * Controls the behavior of the skip navigation link
 */


var SkipNavigationController =
/*#__PURE__*/
function () {
  function SkipNavigationController() {
    _classCallCheck(this, SkipNavigationController);
  }

  _createClass(SkipNavigationController, null, [{
    key: "setFocusInMain",

    /**
     * Sets the focus of the document in the first focusable item in the given main element
     * @param {Node} main
     */
    value: function setFocusInMain(main) {
      if (main !== null) {
        var focusables = main.querySelectorAll(SkipNavigationController.focusableQueryString);

        for (var i = 0; i < focusables.length; i++) {
          if (focusables[i].closest('header') === null) {
            focusables[i].focus();
            break;
          }
        }
      }
    }
  }, {
    key: "mainElement",

    /**
     * Return the <main> tag as a node
     * @return Node
     */
    get: function get() {
      return document.querySelector(SkipNavigationController.skipNavButton.getAttribute('href'));
    }
    /**
     * Returns the string used to find focusable elements
     * @return String
     */

  }, {
    key: "focusableQueryString",
    get: function get() {
      return 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    }
    /**
     * Returns the skip navigation button as a node.
     * @return Node
     */

  }, {
    key: "skipNavButton",
    get: function get() {
      return document.querySelector('.skip-navigation');
    }
  }]);

  return SkipNavigationController;
}(); // Export for Jest testing


if (typeof exports !== 'undefined') {
  module.exports = SkipNavigationController;
} // IIFE


(function () {
  window.addEventListener('DOMContentLoaded', function () {
    var skipNav = SkipNavigationController.skipNavButton;
    var main = SkipNavigationController.mainElement;

    if (skipNav !== null && main !== null) {
      var mainId = main.id; // Resets URL hash, aids when skip nav is toggled more than once in a session.

      skipNav.addEventListener('click', function () {
        window.location.hash = '';
      }); // Sets focus on first focusable item in main when the URL hash changes to main's id

      window.addEventListener('hashchange', function () {
        if (window.location.href.indexOf(mainId) >= 0) {
          SkipNavigationController.setFocusInMain(main);
        }
      });
    }
  });
})();